/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowCookingWithKidsTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowCookingWithKids,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Cook with the Kids!",
    "Cooking with Kids Workshop Awaits!",
    "Fun in the Kitchen Together!",
  ],
  title: "Cooking with Kids",
  description: "Organize a fun cooking workshop for kids.",
  longDescription:
    "Gather your friends and their kids for an exciting cooking workshop! Choose a date, decide on kid-friendly recipes, and plan activities!",
  emoji: "👩",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Cooking with Kids",
          emoji: "👩",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the cooking with kids workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on recipes to cook?",
            description: "What recipes should we focus on during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What recipes should we consider?",
                emoji: "🍪",
                completeAction: {
                  question: "Decide on ingredients needed?",
                  description: "What ingredients should we gather for cooking?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What ingredients should we bring?",
                      emoji: "🥕",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Have Fun Cooking!",
    outroDescription:
      "Your cooking with kids plans are set! Enjoy the fun in the kitchen!",
  },
};
